<template>
  <div class="liu" v-wechat-title="'手持身份证'">
    <camera2 ref="camera" @getImgInfo="getImgInfo" />
    <div>
      <div class="color-f-bg">
        <div class="page-padding-l-r padding-t-10">
          <mt-field label="商户姓名" placeholder="请输入商户姓名" v-model.trim="formData.idCardName" disabled></mt-field>
          <mt-field label="法人身份证" placeholder="请输入法人身份证" v-model.trim="formData.idCardNum" disabled></mt-field>
        </div>
      </div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 margin-t-10 flex color-f-bg">
        <div style="width: 105px">
          <div class="margin-r-10">手持身份证正面照</div>
        </div>
        <div class="flex-1" @click="$refs.camera.imgClick('shouChi')">
          <img :src="shouChi.base64 || require('@/assets/handheld_example@3x.png')" class="faceStyle" />
        </div>
      </div>
      <div>
        <div class="say-color padding-t-10 padding-b-10 page-padding-l-r title-6">
          <span>避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂</span>
          <span v-if="btnStatus == 2">，如对比失败，请</span>
          <span v-if="btnStatus == 2" class="theme-color" @click="resetCameraInfo('shouChi')">重新拍照</span>
          <span v-if="btnStatus == 2">或</span>
          <span v-if="btnStatus == 2" class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
        </div>
      </div>
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" :disabled="shouChiImgShow ? false : true" size="large" @click="submitData">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global wx */

import camera2 from '@/components/camera2.vue';
import { FaceCompare, GetUserStatus } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { upLoadImg } from '@/utils/utils.js';

export default {
  name: 'HandIdCard',
  components: { camera2 },
  data() {
    return {
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
      },
      // 按钮当前的状态
      btnStatus: 1,
      token: '',
      product: '',
      shouChiImgShow: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.idCardName = this.$route.query.idCardName;
      this.formData.idCardNum = this.$route.query.idCardNum;
      this.token = this.$route.query.token;
      this.product = this.$route.query.product;
    });
  },
  methods: {
    // 返回的图片信息
    getImgInfo(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        yes => {
          if (yes.code === 0) {
            if (info.type === 'shouChi') {
              this.shouChiImgShow = true;
              this.shouChi.webUrl = yes.data;
            }
          } else {
            this.resetCameraInfo(info.type);
          }
        },
        no => {
          this.resetCameraInfo(info.type);
        }
      );
    },
    // 提交数据
    submitData() {
      switch (this.btnStatus) {
        case 1:
          this.upLoadData();
          break;
        case 2:
          this.upLoadData();
          break;
      }
    },
    // 提交数据
    upLoadData() {
      CusLoadingOpen();
      FaceCompare({ imageUrl: this.shouChi.webUrl })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.jumpPageStatus();
          } else {
            this.btnStatus = 2;
            CusAlert(res.msg, () => {
              if (res.innerCode === 7776) {
                this.replacePage('ManualAudit', {
                  idCardName: this.formData.idCardName,
                  idCardNum: this.formData.idCardNum,
                  token: this.token,
                  product: this.product,
                });
              }
            });
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 跳转页面的状态
    jumpPageStatus() {
      GetUserStatus().then(res => {
        if (res.code === 0) {
          if (res.data.bankcardStatus === 0) {
            wx.miniProgram.redirectTo({
              url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
            });
          } else if (res.data.bankCreditCardStatus === 0) {
            wx.miniProgram.redirectTo({
              url: `/pages/bankCard/saveCreditcard/saveCreditCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
            });
          } else {
            wx.miniProgram.navigateBack();
          }
        } else {
          CusAlert('认证成功,状态获取有误,返回首页', () => {
            wx.miniProgram.navigateBack();
          });
        }
      });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.btnStatus = staus;
      this.shouChiImgShow = false;
    },
    // 人工审核
    jumpManualAudit() {
      CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
        CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
          this.replacePage('ManualAudit', {
            idCardName: this.formData.idCardName,
            idCardNum: this.formData.idCardNum,
            token: this.token,
            product: this.product,
          });
        });
      });
    },
  },
};
</script>
